import { render, staticRenderFns } from "./ReporteStockCombobox.vue?vue&type=template&id=2613dbf7&scoped=true"
import script from "./ReporteStockCombobox.vue?vue&type=script&lang=js"
export * from "./ReporteStockCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2613dbf7",
  null
  
)

export default component.exports